module.exports = __webpack_public_path__ + "img/Professional-4.1dcf3f1b.png";